/**
 * File Formats
 */
enum FileFormats {
  image = 'image/*',
  video = 'video/*'
}

export { FileFormats };
